import React from "react";
import { Container, Row, Col } from "reactstrap";

const Footer = () => {
  const date = new Date().getFullYear();
  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid={true}>
          <Row>
            <Col md={6}>{date} © DitoBanx.</Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  );
};

export default Footer;
